/**
 * Selectbox component
 */

if (!customElements.get('tpt-selectbox')) {
	customElements.define(
		'tpt-selectbox',
		class TptSelectbox extends HTMLElement {
			constructor() {
				super();

				this.selectedItem(this);
				this.selectHtml = this.querySelector('select');
				this.selectOptions = this.querySelectorAll('tpt-selectbox-option');
			}

			selectedItem(selectbox) {
				const selectBoxlabelValue = selectbox.querySelector('tpt-selectbox-label-value');
				const selectedItem = selectbox.querySelector('tpt-selectbox-option[selected]');
				const textSelected = selectedItem.getAttribute('data-text');

				selectBoxlabelValue.innerHTML = textSelected;

				const selectBoxWidth = selectbox.offsetWidth + 1;
				selectbox.style.width = `${selectBoxWidth}px`;
			}
		}
	);
}

/**
 * Selectbox label
 */

if (!customElements.get('tpt-selectbox-label')) {
	customElements.define(
		'tpt-selectbox-label',
		class TptSelectboxLabel extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showDropdown.bind(this));
			}

			showDropdown() {
				const allSelectBox = document.querySelectorAll('tpt-selectbox');
				const selectBoxElement = this.closest('tpt-selectbox');

				if (selectBoxElement.classList.contains('active')) {
					selectBoxElement.classList.remove('active');
				} else {
					allSelectBox.forEach((selectBox) => {
						selectBox.classList.remove('active');
					});

					selectBoxElement.classList.add('active');
				}
			}
		}
	);
}

/**
 * Selectbox option
 */

if (!customElements.get('tpt-selectbox-option')) {
	customElements.define(
		'tpt-selectbox-option',
		class TptSelectOption extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.changeOption.bind(this));
			}

			selectedItem(selectbox) {
				const selectBoxlabel = selectbox.querySelector('tpt-selectbox-label-value');
				const selectedItem = selectbox.querySelector('tpt-selectbox-option[selected]');
				const textSelected = selectedItem.getAttribute('data-text');

				selectBoxlabel.innerHTML = textSelected;
			}

			changeOption() {
				if (!this.hasAttribute('disabled') && !this.hasAttribute('selected')) {
					const selectbox = this.closest('tpt-selectbox');
					const selectboxHtmlTag = selectbox.querySelector('select');
					const selectOptions = selectbox.querySelectorAll('tpt-selectbox-option');
					const selectOptionsValue = this.getAttribute('data-value');

					selectOptions.forEach((item) => {
						item.removeAttribute('selected');
					});

					this.setAttribute('selected', '');

					this.selectedItem(selectbox);

					selectboxHtmlTag.value = selectOptionsValue;
					selectboxHtmlTag.dispatchEvent(new Event('change'));
					selectbox.classList.remove('active');
				}
			}
		}
	);
}

document.addEventListener(
	'click',
	function (event) {
		if (!event.target.closest('tpt-selectbox')) {
			const allSelectBox = document.querySelectorAll('tpt-selectbox');

			allSelectBox.forEach((selectBox) => {
				selectBox.classList.remove('active');
			});
		}
	},
	false
);
